<script>
import { Field } from 'buefy/dist/components/field'
import { Icon } from 'buefy/dist/components/icon'
import { Input } from 'buefy/dist/components/input'
import { Switch } from 'buefy/dist/components/switch'

export default {
    name : "EditReportingEntityForm",
    components: {
        'b-field' : Field,
        'b-icon' : Icon,
        'b-input' : Input,
        'b-switch' : Switch
    },
    props : {
        data : Object
    },
    data(){
        return {
            newDataToSave : null
        }
    },
    created(){
        this.newDataToSave = {};
        this.$set(this.newDataToSave,'reportingEntity',this.data.reportingEntity);
        this.$set(this.newDataToSave,'repEntityId',this.data.repEntityId);
        if (this.data.isActive===1) {
            this.$set(this.newDataToSave,'isActive',true);
        }
        else {
            this.$set(this.newDataToSave,'isActive',false);
        }
    },
    methods : {
        triggerClose(){
            this.newDataToSave = {};
            this.$emit('close');
        },
        triggerSubmit(){
            this.$emit('submit-newname',this.newDataToSave)
        }
    }
}
</script>

<template>
    <div class="modal-card" style="width:auto">
        <header class="modal-card-head">
            <p class="modal-card-title">Rename Reporting Entity</p>
        </header>
        <section class="modal-card-body">
            <div class="columns">
                <div class="column">
                    <b-field
                        label="New Name">
                        <b-input 
                            v-model="newDataToSave.reportingEntity"
                            type="text"
                            value=""
                            required></b-input>
                    </b-field>
                </div>
            </div>
        </section>
        <footer class="modal-card-foot has-text-left">
            <a class="button is-white"
                v-on:click="triggerClose">
                <span>Cancel</span>
            </a>
            
            <a class="button is-success"
                v-on:click="triggerSubmit"
                v-bind:disabled="newDataToSave.reportingEntity==''">
                <span>Save</span>
            </a>
        </footer>
    </div>
</template>

<style scoped>
</style>





// WEBPACK FOOTER //
// src/components/EditReportingEntityForm.vue